import axios from 'axios';

// Create axios instance
const api = axios.create({
  baseURL: '/api',
  timeout: 10000,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const authType = localStorage.getItem('auth_type');
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');
      localStorage.removeItem('auth_type');
      
      let loginUrl = '/login';
      if (authType === 'apufidc') {
        loginUrl = '/app/apufidc/login';
      } else if (authType === 'crda') {
        loginUrl = '/app/use-cases/login';
      }
      window.location.href = loginUrl;
    }
    return Promise.reject(error);
  }
);

export default api;